import { readArray, readBoolean, readHttpsUrl, readNonEmptyString, readRecord } from '../readers';
import { requestHasStatus } from '../requestError';
import { semanticGet } from '../semanticRepository';
import type { Seller } from './model';

export const readSeller = (value: unknown): Seller => {
  const row = readRecord(value, 'seller');
  const anonymous = readBoolean(row.anonymous, 'seller anonymous');
  return {
    slug: readNonEmptyString(row.slug, 'seller slug'),
    name: readNonEmptyString(row.name, 'seller name'),
    anonymous,
    photoUrl: anonymous ? '' : readHttpsUrl(row.photoUrl, 'seller photo'),
    description: anonymous ? '' : readNonEmptyString(row.description, 'seller description'),
    skus: readArray(row.apis, 'seller APIs').map((sku) => readNonEmptyString(sku, 'seller API')),
  };
};

export const readSellers = (value: unknown): Seller[] =>
  readArray(readRecord(value, 'sellers list').sellers, 'sellers').map(readSeller);

/** The live list of marketplace sellers, from the gateway's public `/sellers`. */
export const fetchSellers = (): Promise<Seller[]> => semanticGet('/sellers', readSellers);

/** One listed seller's page data, or null when no listed seller has the slug. */
export const fetchSeller = async (slug: string): Promise<Seller | null> => {
  try {
    return await semanticGet(`/sellers/${encodeURIComponent(slug)}`, readSeller);
  } catch (error) {
    if (requestHasStatus(error, 404)) return null;
    throw error;
  }
};
